
export default "/assets/house-micro.3cdbe9d3.svg"